import { patch } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

import {
  type UpdateInstantBookRequest,
  workplaceProfileUpdateSchema,
  type WorkplaceResponse,
  workplaceResponseSchema,
} from "./types";

interface UpdateInstantBookParams {
  workplaceId: string;
  data: UpdateInstantBookRequest;
}

export function useUpdateInstantBook(
  options: UseMutationOptions<WorkplaceResponse, unknown, UpdateInstantBookParams> = {}
) {
  return useMutation({
    mutationFn: async ({ workplaceId, data }) => {
      const response = await patch({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/workplaces/${workplaceId}`,
        data: {
          data: {
            id: workplaceId,
            type: "workplace",
            attributes: data,
          },
        },
        requestSchema: workplaceProfileUpdateSchema,
        responseSchema: workplaceResponseSchema,
      });
      return response.data;
    },
    ...options,
  });
}
